exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resultsCounter {\n  margin-left: 20px;\n  font-family: 'Nunito', sans-serif;\n  font-size: 20px;\n  color: #757575; }\n", ""]);

// exports
